module.exports = __webpack_public_path__ + "48dc493d749b812c4f346612595703da.jpg";